<div class="col-md-12 mb-30" *ngIf="Selected_AzmoonMaharat_Record_Switcher=='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات ثبت نام های آزمون مهارت</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">عنوان</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> نوع لیست </label>
          <select (change)="ReadData_AzmoonMaharat()" [(ngModel)]="Filter_Filter_Type" class="custom-select">
            <option value="0">موارد فعال</option>
            <option value="1">موارد حذف شده</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_AzmoonMaharat()" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <button *ngIf="!Procssing && Selected_AzmoonMaharat_Group.id>0" type="button" (click)="Back_Selected_AzmoonMaharat_Group()" class="btn btn-warning"
            style="margin-left: 5px;"> بازگشت </button>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>
      <div class="row"  *ngIf="Selected_AzmoonMaharat_Group.id==0">
        <div class="form-group col-md-4" *ngFor="let item of DataList_AzmoonMaharat_Group">
          <div class="card card-statistics h-100" (click)="Set_Selected_AzmoonMaharat_Group(item)" style="cursor: pointer;">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left">
                  <span class="text-danger">
                    <i class="fa fa-check highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <h6>
                    {{item.title}}
                  </h6>
                </div>
              </div>

            </div>
          </div>
          
        </div>
      </div>


      <div *ngIf="Selected_AzmoonMaharat_Group.id>0" class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شناسه ثبت نام</th>
              <th>کد بهفا</th>
              <th>کد</th>
              <th>عنوان</th>
              <th>مشتری</th>
              <th  *ngIf="Filter_Filter_Type=='1'">شرح حذف</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_AzmoonMaharat
            |filter:Selected_AzmoonMaharat_Group.title:'title'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_AzmoonMaharat|filter:Selected_AzmoonMaharat_Group.title:'title').length
                      }
            ">
              <td>
                <p>{{DataList_AzmoonMaharat.indexOf(item)+1}}</p>
                <span *ngIf="!item.visible" class="badge badge-pill badge-info float-right mt-1">جدید</span>
              </td>
              <td>{{item.id}}</td>
              <td>{{item.codeBehfa}}</td>
              <td>{{item.code}}</td>
              <td>{{item.title}}</td>
              <td>{{item.name}}</td>
              <td *ngIf="Filter_Filter_Type=='1'">{{item.delDes}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;" class="dropdown-item"
                      (click)="Set_Form_AzmoonMaharat_View(item,'Detail')"><i class="fa  fa-file"></i>مراحل</a>
                      <a *ngIf="Filter_Filter_Type=='0'" style="cursor: pointer;" class="dropdown-item" (click)="openModalEdit(templateEdit,item)"><i class="fa fa-edit"></i> ویرایش کدبهفا </a>
                      <a *ngIf="Filter_Filter_Type=='0'" style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-remove"></i> حذف </a>
                    </div>
                  </div>

                  <div *ngIf="item.DeletingProccess">
                    <img src="assets/Loading.gif" style="width: 25px;" />
                  </div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

<div class="col-md-12 mb-30" *ngIf="Selected_AzmoonMaharat_Record_Switcher=='Detail'">
  <app-AzmoonMaharatMainSignInDetail [inner_Del_Filter]="Filter_Filter_Type" [inner_AzmoonMaharatMain]="Selected_AzmoonMaharat_Record"
    (outter_AzmoonMaharatMain)="Set_List_AzmoonMaharat_View($event)">
  </app-AzmoonMaharatMainSignInDetail>
</div>

<ng-template #template>
  <div class="modal-header">
     <h4 class="modal-title pull-left">تایید حذف اطلاعات ثبت نام با شناسه  '{{Data_Seleted_Delete.id}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> شرح حذف </label>
          <input [(ngModel)]="Filter_dsc" name="Filter_dsc" type="text" class="form-control"
            placeholder="اینجا تایپ کنید ...">
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" [disabled]="!Filter_dsc" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete)"> حذف اطلاعات <i class="fa fa-remove"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateEdit>
  <div class="modal-header">
     <h4 class="modal-title pull-left">ویرایش کدبهفا با شناسه  '{{Data_Seleted_Delete.id}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Edit.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> کدبهفا </label>
          <input [(ngModel)]="Filter_CodeBehfa" name="Filter_CodeBehfa" type="text" class="form-control"
            placeholder="اینجا تایپ کنید ...">
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" [disabled]="!Filter_CodeBehfa" class="btn btn-warning" (click)="Edit(Data_Seleted_Delete)"> ویرایش اطلاعات <i class="fa fa-edit"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Edit.hide()">بستن</button>
  </div>
</ng-template>
